import { render, staticRenderFns } from "./OverduesDetail.vue?vue&type=template&id=7b19caa6&scoped=true&"
import script from "./OverduesDetail.vue?vue&type=script&lang=js&"
export * from "./OverduesDetail.vue?vue&type=script&lang=js&"
import style0 from "./OverduesDetail.vue?vue&type=style&index=0&id=7b19caa6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b19caa6",
  null
  
)

export default component.exports